/*eslint-disable*/
import React from 'react'
import { Icon } from 'semantic-ui-react'
function JobcardStatus(props) {
    let mainData = props.data
    return (
        <>
            {mainData && mainData.statusId === null || mainData && mainData.statusId === 0 ? <strong className="w3-text-green"><Icon name="info circle" />Jobcard Created</strong> :
                <strong
                    className={mainData && mainData.statusId === 2 ? 'w3-text-blue' : mainData && mainData.statusId === 4 ? 'w3-text-red' : mainData && mainData.statusId === 2 ? 'w3-text-orange' : mainData && mainData.statusId === 4 ? 'w3-text-red' : mainData && mainData.statusId === 3 ? 'w3-text-green' : ''}>
                    <Icon name={mainData && mainData.statusId === 3 ? 'check circle' : mainData && mainData.statusId === 2 ? 'clock' : mainData && mainData.statusId === 1 || mainData && mainData.statusId === '' ? 'info circle' : mainData && mainData.statusId === 3 ? 'times circle' : ''} />{mainData && mainData.status ? `${mainData.status} (${mainData.statusDate})` : `Jobcard Created (${mainData && mainData.jobdate})`}</strong>
            }
        </>
    )
}

export default JobcardStatus
